import { render, staticRenderFns } from "./TouchPointInfo.vue?vue&type=template&id=657b6ff7&scoped=true&"
import script from "./TouchPointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchPointInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouchPointInfo.vue?vue&type=style&index=0&id=657b6ff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b6ff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657b6ff7')) {
      api.createRecord('657b6ff7', component.options)
    } else {
      api.reload('657b6ff7', component.options)
    }
    module.hot.accept("./TouchPointInfo.vue?vue&type=template&id=657b6ff7&scoped=true&", function () {
      api.rerender('657b6ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/TouchPointInfo.vue"
export default component.exports